/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("pgcManuscriptDetailsModule", ["pgcManuscriptDetailsRouter"]).
controller("pgcManuscriptDetailsCtrl", ["$scope", "$element", "$compile", "$timeout", "$q", "httpService", '$filter', '$stateParams', '$sce', function($scope, $element, $compile, $timeout, $q, httpService, $filter, $stateParams, $sce) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            isShowTimeDetal: false, //是否显示时间详情
        };
        $scope.simpleMode = {

        };
        $scope.calendar = {};
        $scope.listData = [];
        $scope.page = {
            "CURRPAGE": 0,
            "PAGESIZE": 10,
            "ITEMCOUNT": 0
        };
        $scope.params = {
            articleId: $stateParams.articleId
        };
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        requestData().then(function() {
            initActivityDateAndTime();
        });
    }
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {
        var deffer = $q.defer();
        $scope.loadingPromise = httpService.http("/mcnww/web/pgcArticle/findById.do", $scope.params, "get").then(function(data) {
            $scope.listData = data.articeInfo;
            $scope.listData.articleHtmlCon = $sce.trustAsHtml(data.articeInfo.articleHtmlCon);
            $scope.status.channels = data.chnlsAndTags;
            deffer.resolve();
            // $scope.imgArry = data.articeInfo.coverImg.substr(2, data.articeInfo.coverImg.length - 3).split(',');
            // var newImgArry = [];
            // var handleImgArry = [];
            // for (var i = 0; i < $scope.imgArry.length; i++) {
            //     if ($scope.imgArry[i].indexOf("null")) {
            //         newImgArry.push($scope.imgArry[i]);
            //     }
            // }
            // if (newImgArry.length > 0) {
            //     handleImgArry.push($scope.imgArry[0].substr(0, $scope.imgArry[0].length - 1));
            //     handleImgArry.push($scope.imgArry[1].substr(1, $scope.imgArry[0].length - 1));
            //     handleImgArry.push($scope.imgArry[2].substr(1, $scope.imgArry[0].length - 1));
            // }


            // $scope.imgArry = handleImgArry;
        });
        return deffer.promise;
    }
    /**
     * [initActivityDateAndTime description] 初始化活动日期和时间
     * @return {[type]} [description]
     */
    function initActivityDateAndTime() {
        $scope.listData.activityTime = JSON.parse($scope.listData.activityTime);
        if ($scope.listData.activityTimeMode === 1) { //日历模式
            initCalendarData().then(function() {
                loadDateSlider();
            });
        } else { //简单模式
            $scope.simpleMode.startDate = $filter("date")($scope.listData.activityTime.date[0], 'yyyy年MM月dd日');
            $scope.simpleMode.endDate = $filter("date")($scope.listData.activityTime.date[1], 'yyyy年MM月dd日');
            $scope.simpleMode.startTime = $scope.listData.activityTime.time[0];
            $scope.simpleMode.endTime = $scope.listData.activityTime.time[1];
        }
    }
    /**
     * [initCalendarData description] 初始化日历数据
     * @return {[type]} [description]
     */
    function initCalendarData() {
        var deffer = $q.defer();
        $scope.calendar.data = $scope.listData.activityTime[0];
        $scope.calendar.data.sort(function(x, y) {
            return x.start - y.start;
        });
        $scope.calendar.startDate = $filter("date")($scope.calendar.data[0].start, "yyyy年MM月dd日");
        var tempData = angular.copy($scope.calendar.data);
        tempData.sort(function(x, y) {
            return y.end - x.end;
        });
        $scope.calendar.endDate = $filter("date")(tempData[0].end - (1000 * 3600 * 24), "yyyy年MM月dd日");
        var tempObject = {};
        for (var i in $scope.calendar.data) {
            var theDate = $scope.calendar.data[i];
            var attribute = theDate.start + "-" + theDate.end;
            if (!tempObject[attribute]) {
                tempObject[attribute] = [theDate];
            } else {
                tempObject[attribute].push(theDate);
            }
        }
        var tempArray = [];
        for (var j in tempObject) {
            tempArray.push(tempObject[j]);
        }
        tempArray.sort(function(x, y) {
            return x[0].start - y[0].start;
        });
        $timeout(function() {
            $scope.calendar.data = tempArray;
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [loadDateSlider description] 初始化日期滑动组件
     * @return {[type]} [description]
     */
    function loadDateSlider() {
        var $dateSlider = $(document.createElement("date-slider"));
        $dateSlider.attr({
            "date-array": "calendar.data",
            "callback": "dateRangeSelect()",
            "selected-date-range": "calendar.selectedDateRange"
        });
        $dateSlider = $compile($dateSlider)($scope);
        $element.find(".dateSlider").append($dateSlider);
    }
    /**
     * [dateRangeSelect description] 选择时间段回调函数
     * @return {[type]} [description]
     */
    $scope.dateRangeSelect = function() {
        $timeout(function() {
            $scope.calendar.selectedDateRange_ = angular.copy($scope.calendar.selectedDateRange);
            delete $scope.calendar.selectedDateRange_.$$hashKey;
            delete $scope.calendar.selectedDateRange_.dateRange;
        });
    };
    /**
     * [handleSelectedDateRange description] 处理选中时间段数据
     * @param {[object]} [item] [description] 时间段
     * @return {[type]} [description]
     */
    $scope.handleSelectedDateRange = function(item) {
        var date = new Date(item.start);
        item.day = getDayZH(date.getDay());
        item.date = "(" + $filter("date")(date, "MM月dd日") + ")";
        item.timeRange = item.startEndTime[0] + "-" + item.startEndTime[1];
    };
    /**
     * [getDay description] 获取星期数中文
     * @return {[type]} [description]
     */
    function getDayZH(day) {
        var dayZh;
        switch (day) {
            case 0:
                dayZh = "周日";
                break;
            case 1:
                dayZh = "周一";
                break;
            case 2:
                dayZh = "周二";
                break;
            case 3:
                dayZh = "周三";
                break;
            case 4:
                dayZh = "周四";
                break;
            case 5:
                dayZh = "周五";
                break;
            case 6:
                dayZh = "周六";
                break;
            default:
                dayZh = "未知";
        }
        return dayZh;
    }
    /**
     * [initCover description] 初始化封面
     * @param  {[type]} item [description] 渠道信息
     * @return {[type]}      [description]
     */
    $scope.initCover = function(item) {
        item.coverImg = JSON.parse(item.coverImg);
    };
    /**
     * [handleRemark description] 处理备注问题
     * @return {[type]} [description]
     */
    $scope.handleRemark = function() {
        if (!$scope.listData || !$scope.listData.activityRemark) return "";
        return $sce.trustAsHtml($scope.listData.activityRemark.replace(/\n/g, "<br>").replace(/ /g, "&nbsp;"));
    };

}]);